define([
  "globals",
  "knockout",
  "jquery"],
function (globals, ko, $) {

  // Blinds.ca Product Reviews module

  "use strict";

  var Reviews = function(productId, aliasId) {

    var self = this;
    self.productId = productId;
    self.aliasId = aliasId;
    self.hideReviews = ko.observable(true);
    self.$BVCheck;

    self.isMobile = globals.ssm.getState("mobile").active;
    self.hideSection = ko.observable(self.isMobile);
    self.hasReviews = ko.observable(true);
    self.buttonText = ko.observable("Show individual reviews");

    self.ratingWidth = function(ratingValue) {
      var percentage = ratingValue ? ((ratingValue / 5) * 100) : 0;
      return percentage + "%";
    };

    self.numReviews = ko.observable(0);
    self.scrollToSection = function(hash) {
      if ((hash == "testimonials" || hash == "BVRRWidgetID") && self.hasReviews()) {
        self.showContent();
        $("html, body").animate({
          scrollTop: $("#testimonials").offset().top
        }, 1000);
      }
    }

    self.processReviewData = function(result, callback) {

      // Hiding reviews summary container if there are no reviews
      if (result.TotalReviewCount === 0) {
        $("#BVRRSummaryContainer").hide();
      }

      self.numReviews(result.TotalReviewCount);
      self.hasReviews(result.TotalReviewCount > 0);

      if (result.TotalReviewCount > 0) {

        // Update reviews on mobile
        var ratingValue = $("span[itemprop=ratingValue]").text();
        $(".bdc-product-ratingstars-total").css("width", self.ratingWidth(ratingValue));
        $(".bdc-product-mobile-ratings-text").append("(" + result.TotalReviewCount + " Reviews)");

        // Redirect from PIP
        if (location.search.indexOf("tab=reviews") > -1) {
          if (self.isMobile) {
            $("#testimonials .bdc-product-details-title").trigger("click");
          }
          location.hash = "#testimonials";
        }

        var hash = window.location.hash.slice(1);
        self.scrollToSection(hash);

        // Click on show reviews
        $(window).on("hashchange", function () {
          var internalhash = window.location.hash.slice(1);
          if (internalhash == "BVRRWidgetID" && self.hasReviews()) {
            self.showContent();
            self.toggleSection();
          }
        });

        $("dd.bv-rating-ratio-count, .bdc-product-mobile-ratings-text").on("click", function() {
          self.showContent();
          if (self.isMobile) {
            self.toggleSection();
          }
          self.scrollToSection("testimonials");
        });

      } else {
        $(".bdc-product-mobile-ratings").hide();
        $(".bdc-product-name-brand-wrapper").css("margin-bottom", "1em");
      }

      if (callback) {
        callback(result.TotalReviewCount);
      }

    };

    self.getReviewData = function(callback) {
      self.$BVCheck = window.setInterval(function() {
        var result = window.$BVResult;
        if (result) {
          window.clearInterval(self.$BVCheck);
          self.processReviewData(result, callback);
        }
      }, 1000);
    }

    self.showContent = function () {
      self.hideReviews(false);
      self.buttonText("Hide individual reviews");
    };

    this.toggleSection = function(viewModel, event) {
      self.hideSection(!self.hideSection());
      location.hash = "";
      if (history.pushState) {
        history.pushState("", document.title, window.location.pathname);
      }
      if (event && self.hideSection() === false) {
        event.preventDefault();
      }
    };

    this.toggleDetails = function () {
      self.hideReviews(!self.hideReviews());
      if (self.hideReviews()) {
        location.hash = "";
        self.buttonText("Show individual reviews");
      } else {
        if (!self.isMobile) {
          location.hash = "";
          location.hash = "#testimonials";
        }
        self.buttonText("Hide individual reviews");
      }
    };

  }

  return Reviews;

});
